import { useLocation } from "react-router-dom";
import { PRODUCTS } from "@/data/products";
import { whatsappLink, WHATSAPP_MESSAGES } from "@/config/site";
import { trackEvent } from "@/lib/analytics";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";

export const FloatingWhatsApp = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const product = PRODUCTS.find((p) => p.path === pathname);
  const message = product ? product.whatsappMessage : WHATSAPP_MESSAGES.general;
  return (
    <a
      href={whatsappLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={product ? `WhatsApp Uhlumo Organics about ${product.name}` : "WhatsApp Uhlumo Organics"}
      onClick={() => trackEvent("whatsapp_click", { product: product?.slug || "general", location: "floating" })}
      className="fixed bottom-4 right-4 z-40 inline-flex h-14 items-center gap-2 rounded-full bg-[#1f6f4a] pl-4 pr-5 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(31,111,74,0.35)] transition-colors hover:bg-[#195c3d] sm:bottom-6 sm:right-6"
      data-testid="floating-whatsapp-button"
    >
      <WhatsAppIcon className="h-6 w-6" />
      <span className="hidden sm:inline">WhatsApp us</span>
    </a>
  );
};
